import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import cryptoJs from 'crypto-js'
let keyOne = 'pinming@20180821'
// 加密函數
export function aesEncrypt(word, aesSecrect) {
  if (aesSecrect === undefined || aesSecrect == '') {
    aesSecrect = keyOne
  }
  let key = cryptoJs.enc.Utf8.parse(aesSecrect)
  let enc = ''

  enc = cryptoJs.AES.encrypt(word, key, {
    iv: cryptoJs.enc.Utf8.parse(aesSecrect.substr(0, 16)),
    mode: cryptoJs.mode.CBC,
    padding: cryptoJs.pad.Pkcs7
  })
  let encResult = enc.toString()
  return encResult
}

/**
 * 解密函數
 * @param {*} word
 */
export function  aesDecrypt(word, aesSecrect) {
  if (aesSecrect === undefined || aesSecrect == '') {
    aesSecrect = keyOne
  }
  let key = cryptoJs.enc.Utf8.parse(aesSecrect)
  let dec = cryptoJs.AES.decrypt(word, key, {
    iv: cryptoJs.enc.Utf8.parse(aesSecrect.substr(0, 16)),
    mode: cryptoJs.mode.CBC,
    padding: cryptoJs.pad.Pkcs7
  })
  let decData = cryptoJs.enc.Utf8.stringify(dec)
  return decData
}

/**
 * 获取uuid
 */
export function getUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })
}

export function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
}
/**
 * 获取给定日期周一日期
 */
export function getCurrentWeekFirstDay(date) {
  if(date==null){
    return '';
  }
  if(!(date instanceof Date)){
    date=new Date(date.replace(/-/g,"/"));
  }
  let weekFirstDay = new Date(date - (date.getDay() - 1) * 86400000)
  let firstMonth = Number(weekFirstDay.getMonth()) + 1
  if (firstMonth < 10) {
    firstMonth = '0' + firstMonth
  }
  let weekFirstDays = weekFirstDay.getDate();
  if (weekFirstDays < 10) {
    weekFirstDays = '0' + weekFirstDays;
  }
  return weekFirstDay.getFullYear() + '-' + firstMonth + '-' + weekFirstDays;
}
/**
 * 获取给定日期周日日期
 */
export function getCurrentWeekLastDay(date) {
  if(date==null){
    return '';
  }
  if(!(date instanceof Date)){
    date=new Date(date.replace(/-/g,"/"));
  }
  let weekFirstDay = new Date(date - (date.getDay() - 1) * 86400000)
  let weekLastDay = new Date((weekFirstDay / 1000 + 6 * 86400) * 1000)
  let lastMonth = Number(weekLastDay.getMonth()) + 1
  if (lastMonth < 10) {
    lastMonth = '0' + lastMonth
  }
  let weekLastDays = weekLastDay.getDate();
  if (weekLastDays < 10) {
    weekLastDays = '0' + weekLastDays;
  }
  return weekLastDay.getFullYear() + '-' + lastMonth + '-' + weekLastDays;
}

/**
 * 获取给定日期月初日期
 */
export function getCurrentMonthFirstDay(date) {
  if(date==null){
    return '';
  }
  if(!(date instanceof Date)){
    date=new Date(date.replace(/-/g,"/"));
  }
  date.setDate(1);
  let month = parseInt(date.getMonth() + 1);
  let day = date.getDate();
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  return date.getFullYear() + '-' + month + '-' + day;
}
/**
 * 获取给定日期月末日期
 */
export function getCurrentMonthLastDay(date) {
  if(date==null){
    return '';
  }
  if(!(date instanceof Date)){
    date=new Date(date.replace(/-/g,"/"));
  }
  let currentMonth = date.getMonth();
  let nextMonth = ++currentMonth;
  let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
  let oneDay = 1000 * 60 * 60 * 24;
  let lastTime = new Date(nextMonthFirstDay - oneDay);
  let month = parseInt(lastTime.getMonth() + 1);
  let day = lastTime.getDate();
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  return date.getFullYear() + '-' + month + '-' + day;
}

/**
 * 校验手机号
 * @param name
 * @returns {string|null}
 */
export function checkPhone(rule, value, callback) {
  if (!value) {
    callback(new Error('请输入手机号'));
  } else {
    const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的手机号'))
    }
  }
}

/**
 * 校验金额
 * @param name
 * @returns {string|null}
 */
export function checkCurrency(rule, value, callback) {
  if (!value) {
    callback(new Error('请输入金额数字'));
  } else {
    const reg = /^\d{1,16}(\.\d{1,6})?$/
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的金额，整数位不得超过16位，小数位不得超过四位。'))
    }
  }
}

/**
 * 校验手机号
 * @param name
 * @returns {string|null}
 */
export function checkPhoneReg(rule, value, callback) {
  const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/
  if (reg.test(value) || value == '') {
    callback()
  } else {
    return callback(new Error('请输入正确的手机号'))
  }
}

/**
 * 校验身份证号
 * @param name
 * @returns {callback}
 */
export function isIdentityId(rule,value,callback) {
  if(!value){
    callback(new Error('请输入身份证号'));
  }else{
    var patrn = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;//长度或格式校验
    //地区校验
    var aCity = {
      11: "北京",
      12: "天津",
      13: "河北",
      14: "山西",
      15: "内蒙古",
      21: "辽宁",
      22: "吉林",
      23: "黑龙江",
      31: "上海",
      32: "江苏",
      33: "浙江",
      34: "安徽",
      35: "福建",
      36: "江西",
      37: "山东",
      41: "河南",
      42: "湖北",
      43: "湖南",
      44: "广东",
      45: "广西",
      46: "海南",
      50: "重庆",
      51: "四川",
      52: "贵州",
      53: "云南",
      54: "西藏",
      61: "陕西",
      62: "甘肃",
      63: "青海",
      64: "宁夏",
      65: "新疆",
      71: "台湾",
      81: "香港",
      82: "澳门",
      91: "国外"
    };
    // 出生日期验证
    var sBirthday = (
            value.substr(6, 4) +
            "-" +
            Number(value.substr(10, 2)) +
            "-" +
            Number(value.substr(12, 2))
        ).replace(/-/g, "/"),
        d = new Date(sBirthday)
    // 身份证号码校验 最后4位  包括最后一位的数字/字母X
    var sum = 0,
        weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
        codes = "10X98765432";
    for (var i = 0; i < value.length - 1; i++) {
      sum += value[i] * weights[i];
    }
    var last = codes[sum % 11]; //计算出来的最后一位身份证号码

    if (value == '') {
      return callback(new Error("身份证号不能为空"));
    } else if (!patrn.exec(value)) {
      return callback(new Error("你输入的身份证长度或格式错误"));
    } else if (!aCity[parseInt(value.substr(0, 2))]) {
      return callback(new Error("你的身份证地区非法"));
    } else if (sBirthday != d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()) {
      return callback(new Error("身份证上的出生日期非法"));
    } else if (value[value.length - 1] != last) {
      return callback(new Error("你输入的身份证号非法"));
    }else{
      return callback();
    }
  }

}

/**
 * 回滚到顶部
 */
export function  scrollToTop (callback) {
  let timer = null
  cancelAnimationFrame(timer)
  timer = requestAnimationFrame(function fn () {
    let documentScrollTop = document.documentElement.scrollTop
    if (documentScrollTop > 5000) {
      documentScrollTop -= 1000
      document.documentElement.scrollTop = documentScrollTop
      timer = requestAnimationFrame(fn)
    } else if (documentScrollTop > 1000 && documentScrollTop <= 5000) {
      documentScrollTop -= 500
      document.documentElement.scrollTop =  documentScrollTop
      timer = requestAnimationFrame(fn)
    } else if (documentScrollTop > 200 && documentScrollTop <= 1000) {
      documentScrollTop -= 100
      document.documentElement.scrollTop = documentScrollTop
      timer = requestAnimationFrame(fn)
    } else if (documentScrollTop > 50 && documentScrollTop <= 200) {
      documentScrollTop -= 10
      document.documentElement.scrollTop = documentScrollTop
      timer = requestAnimationFrame(fn)
    } else if (documentScrollTop > 0 && documentScrollTop <= 50) {
      documentScrollTop -= 5
      document.documentElement.scrollTop = documentScrollTop
      timer = requestAnimationFrame(fn)
    } else {
      cancelAnimationFrame(timer)
      if(callback)callback();
    }
  })
}

export function  scrollToDown (position) {
  let timer = null
  cancelAnimationFrame(timer)
  timer = requestAnimationFrame(function fn () {
    let documentScrollTop = document.documentElement.scrollTop
    if(position>document.documentElement.scrollTop){
      documentScrollTop +=10
      document.documentElement.scrollTop = documentScrollTop
      timer = requestAnimationFrame(fn)
    } else {
      cancelAnimationFrame(timer)
    }
    
  })
}

/**
 * tag 标签类型转换
 * @param type
 * @param key
 * @returns {*}
 */
export function formatterTagType(type,key){

  if(key == 'witnessStatus'){
    switch(type){
      case 1 : return ''; break;
      case 2 : return 'success'; break;
      case 3 : return 'danger'; break;
    }
  }

  if(key == 'personRole'){
    switch(type){
      case 1: return ''; break;
      case 2: return 'danger'; break;
      case 3: return 'warning'; break;
      case 4: return 'success'; break;
      case 5: return 'success'; break;
      case 9: return 'info'; break;
    }
  }


  if(key == 'projectType'){
    switch(type){
      case 'GC': return 'danger'; break;
      case 'CG': return 'success'; break;
      case 'GT' : return ''; break;
      case 'CQ' : return 'warning'; break;
      case 'QT' : return 'info'; break;
    }
  }

  if(key == 'roleType'){
    switch(type){
      case '1': return ''; break;
      case '2': return 'success'; break;
      case '3' : return 'warning'; break;
      case '4' : return 'danger'; break;
      case '9' : return 'info'; break;
    }
  }

  if(key == 'cateQuestState'){
    switch(type){
      case -1: return 'info'; break;
      case 1: return 'success'; break;
      case 0 : return ''; break;
    }
  }

  return ""
}

export function formatterDataDictionary(list,value) {
  const item = list.filter(sl => sl.value == value)[0];
  return item != null ? item.name : "";
}

export function dealAttachment(att,data) {
    console.log(att,data,"att,data");
  let attachments = JSON.parse(JSON.stringify(att))
  if (data && data.length > 0) {
    data.forEach((item,index)=>{
      var idx = attachments.findIndex(function(it) {
        return it.fileType == item.fileType;
      });
      if(idx > -1){
        attachments[idx].id = item.id;
        attachments[idx].name = item.name;
        attachments[idx].filePath = item.filePath;
        attachments[idx].bizId = item.bizId;
      }
    //    var idx = attachments.findIndex(function(it) {
    //     return it.fileType == item.fileType;
    //   });
    //   if(idx > -1){
    //     if(attachments[idx].id){
    //         let obj=JSON.parse(JSON.stringify(attachments[idx]))
    //         obj.id = item.id;
    //         obj.name = item.name;
    //         obj.filePath = item.filePath;
    //         obj.bizId = item.bizId;
    //         attachments.push(obj)
    //     }else{
    //         attachments[idx].id = item.id;
    //         attachments[idx].name = item.name;
    //         attachments[idx].filePath = item.filePath;
    //         attachments[idx].bizId = item.bizId;
    //     }
        
    //   }
    })
  }
 return attachments
}


/**
 * 格式化日期
 * @param date
 * @param fmt
 * @returns {string}
 */
export function formatDate(date,fmt) {
  if(date==null){
    return '';
  }
  if(typeof date == 'number'){
    date=new Date(date);
  }

  if(!(date instanceof Date)){
    date=new Date(date.replace(/-/g,"/"));
  }

  if(date.getFullYear() == '9099'){
    return '永久'
  }
  let str=fmt.replace("yyyy",date.getFullYear()).replace("MM",parseIntforLen(date.getMonth()+1,2))
      .replace("dd",parseIntforLen(date.getDate(),2)).replace("HH",parseIntforLen(date.getHours(),2))
      .replace("mm",parseIntforLen(date.getMinutes(),2)).replace("ss",parseIntforLen(date.getSeconds(),2))
  return str;
}

/**
 * 格式化数字 补零
 * @param num
 * @param len
 * @returns {*}
 */
export function parseIntforLen(num,len) {
  if(String(num).length > len) return num;
  return (Array(len).join(0) + num).slice(-len);

}

/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth(key) {
  return JSON.parse(sessionStorage.getItem('permissions') || '[]').indexOf(key) !== -1 || false
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate(data, id = 'id', pid = 'parentId') {
  var res = []
  var temp = {}
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i]
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]['children']) {
        temp[data[k][pid]]['children'] = []
      }
      if (!temp[data[k][pid]]['_level']) {
        temp[data[k][pid]]['_level'] = 1
      }
      data[k]['_level'] = temp[data[k][pid]]._level + 1
      temp[data[k][pid]]['children'].push(data[k])
    } else {
      res.push(data[k])
    }
  }
  return res
}

/**
 * 清除登录信息
 */
export function clearLoginInfo() {
  Vue.cookie.delete(window.SITE_CONFIG.uid)
  store.commit('resetStore')
  router.options.isAddDynamicMenuRoutes = false
}

/**
 * 时间转换，去 UTC+8 。默认时间不需要时区(只有在时间重新构造时才处理)
 * @param date
 */
export function parseToDate(date) {
  if (date === undefined || date === null) {
    date = new Date()
  } else if (date instanceof Date) {
    return date
  } else {
    date = new Date(date)
  }
  return new Date(date - date.getTimezoneOffset())
}


/**
 * 时间转换，去 UTC+8 。默认时间不需要时区
 * @param date
 * @param useRaw
 */
export function getMonth(date, useRaw) {
  return parseToDate(date).getMonth() + 1
}

/**
 * 时间转换，去 UTC+8 。默认时间不需要时区
 * @param date 当前时间
 * @param offsetMonth 月份便宜
 */
export function getFullMonth(date, offsetMonth) {
  var cur = parseToDate(date);
  if (offsetMonth !== undefined && offsetMonth !== 0) {
    cur = addMonth(cur, offsetMonth)
  }
  return cur.getFullYear() * 100 + cur.getMonth() + 1
}

/**
 * 时间转换，去 UTC+8 。默认时间不需要时区
 * @param date
 */
export function getYear(date) {
  return parseToDate(date).getFullYear()
}

/**
 * 时间转换，去 UTC+8 。默认时间不需要时区
 * @param date
 * @param count
 */
export function addMonth(date, count) {
  var newDate
  if (date instanceof Date) {
    newDate = new Date(date)
  } else {
    newDate = new Date(parseToDate(date))
  }
  newDate.setMonth(newDate.getMonth() + count)
  return newDate
}


//设置默认日期
export function getMonthPickDefaultDate() {
  //获取新的时间(2019.4.12）
  let date = parseToDate()
  let fromDate = addMonth(date, -6)
  let endDate = addMonth(date, 1)
  //字符串拼接，开始时间，结束时间
  var month = fromDate.getMonth() + 1;
  let beg = fromDate.getFullYear() + '-' + (month < 10 ? '0' : '') + month
  month = endDate.getMonth() + 1;
  let end = endDate.getFullYear() + '-' + (month < 10 ? '0' : '') + month
  return [beg, end] //将值设置给插件绑定的数据
}

/**
 * 将日期选择的月度范围 转换为 统计要求的 [20190101,20190101]格式
 * @param value
 */
export function parseMonthPickValue(value) {
  if (value === undefined || value.length < 2 || value[0] === undefined || value[1] === undefined) {
    value = getMonthPickDefaultDate()
  }
  var fromDate = value[0]
  var endDate = value[1]
  let result = {}
  if (fromDate.length <= 7) {
    fromDate = fromDate + '-' + '01'
    result.from = getFullMonth(fromDate)
  } else {
    result.from = getFullMonth(new Date(fromDate))
  }
  if (endDate.length <= 7) {
    endDate = endDate + '-' + '01'
    result.end = getFullMonth(endDate, 1)
  } else {
    result.end = getFullMonth(new Date(endDate), 1)
  }
  return result
}

/**
 * JS获取URL中参数值
 * @param name
 * @returns {string|null}
 */
export function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}




// 获取系统信息
export function getOsInfo(){
  var userAgent = navigator.userAgent.toLowerCase();
  var name = "Unknown";
  var version = "Unknown";
  if (userAgent.indexOf("win") > -1) {
    name = "Windows";
    if (userAgent.indexOf("windows nt 5.0") > -1) {
      version = "Windows 2000";
    } else if (
        userAgent.indexOf("windows nt 5.1") > -1 ||
        userAgent.indexOf("windows nt 5.2") > -1
    ) {
      version = "Windows XP";
    } else if (userAgent.indexOf("windows nt 6.0") > -1) {
      version = "Windows Vista";
    } else if (
        userAgent.indexOf("windows nt 6.1") > -1 ||
        userAgent.indexOf("windows 7") > -1
    ) {
      version = "Windows 7";
    } else if (
        userAgent.indexOf("windows nt 6.2") > -1 ||
        userAgent.indexOf("windows 8") > -1
    ) {
      version = "Windows 8";
    } else if (userAgent.indexOf("windows nt 6.3") > -1) {
      version = "Windows 8.1";
    } else if (
        userAgent.indexOf("windows nt 6.2") > -1 ||
        userAgent.indexOf("windows nt 10.0") > -1
    ) {
      version = "Windows 10";
    } else {
      version = "Unknown";
    }
  } else if (userAgent.indexOf("iphone") > -1) {
    name = "Iphone";
  } else if (userAgent.indexOf("mac") > -1) {
    name = "Mac";
  } else if (
      userAgent.indexOf("x11") > -1 ||
      userAgent.indexOf("unix") > -1 ||
      userAgent.indexOf("sunname") > -1 ||
      userAgent.indexOf("bsd") > -1
  ) {
    name = "Unix";
  } else if (userAgent.indexOf("linux") > -1) {
    if (userAgent.indexOf("android") > -1) {
      name = "Android";
    } else {
      name = "Linux";
    }
  } else {
    name = "Unknown";
  }
  return { name, version };
}
/**
 * 设置SessionStorage
 */
export function setSessionStorage  (key, val){
  if (key) {
    let obj = JSON.stringify(val);
    sessionStorage.setItem(key, obj)
  }
}
/**
 * 获取SessionStorage
 */
export function getSessionStorage (key){
  let val = sessionStorage.getItem(key);
  return val ? JSON.parse(val) : false;
}

export function IEVersion () {
  var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
  var isIE =
      userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
  var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
  var isIE11 =
      userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
  if (isIE) {
    var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
    reIE.test(userAgent);
    var fIEVersion = parseFloat(RegExp["$1"]);
    if (fIEVersion == 7) {
      return 7;
    } else if (fIEVersion == 8) {
      return 8;
    } else if (fIEVersion == 9) {
      return 9;
    } else if (fIEVersion == 10) {
      return 10;
    } else {
      return 6; //IE版本<=7
    }
  } else if (isEdge) {
    return "edge"; //edge
  } else if (isIE11) {
    return 11; //IE11
  } else {
    return -1; //不是ie浏览器
  }
}

//是否IE浏览器
export function isIEBrowser() {
  let IEV = IEVersion()
  return IEV > -1?true:false;
}

//是否Firefox浏览器
export function isFirefoxBrowser() {
  //判断是否为Firefox内核浏览器
  var u = window.navigator.userAgent.toLocaleLowerCase();

  var firefox = /(firefox)\/([\d.]+)/;
  var b = u.match(firefox);
  if (b) {
    return true;
  } else {
    return false;
  }
}

// 插入iframe
export function iframeInsert ($el)  {
  if (isIEBrowser()) {
    let html = '<iframe style="position:absolute;z-index:-1;width:100%;height:100%;top:0;left:0;right:0;bottom:0" allowtransparency="true" src="" frameborder="0"></iframe>';
    $el.querySelector(".el-dialog").insertAdjacentHTML("afterbegin", html);
  }
}

export function nearSixYearsList(currentYear){
  let yearsList = [], thisYear = new Date().getFullYear();
  if(thisYear - currentYear == 0){
    for(var i = 0;i<6;i++){
      yearsList.push(currentYear-i)
    }
  }else if(thisYear - currentYear == 1){
    for(var j = 0;j<5;j++){
      yearsList.push(currentYear-j)
    }
    yearsList.unshift(currentYear+1)
  }else{
    for(var k = 0;k<4;k++){
      yearsList.push(currentYear-k)
    }
    yearsList.unshift(currentYear+1);
    yearsList.unshift(currentYear+2)
  }
  return yearsList;
}

export function IsIE(){
	//判断是否为IE内核浏览器
	var u = window.navigator.userAgent.toLocaleLowerCase();
	var msie = /(msie) ([\d.]+)/;
	var chrome = /(chrome)\/([\d.]+)/;
	var firefox = /(firefox)\/([\d.]+)/;
	var safari = /(safari)\/([\d.]+)/;
	var opera = /(opera)\/([\d.]+)/;
	var ie11 = /(trident)\/([\d.]+)/;
	var b = u.match(msie)||u.match(chrome)||u.match(firefox)||u.match(safari)||u.match(opera)||u.match(ie11);
	if(b[1] == "msie" || b[1] == 'trident'){
		return true;
	}else{
		return false;
	}
}

export function getNewTime(){
	var myDate = new Date;
	var year = myDate.getFullYear(); //获取当前年
	var mon = myDate.getMonth() + 1; //获取当前月
	var date = myDate.getDate(); //获取当前日
	var hours = myDate.getHours(); //获取当前小时
	var minutes = myDate.getMinutes(); //获取当前分钟
	var seconds = myDate.getSeconds(); //获取当前秒
	if(IsIE()){
		var now = year + "/" + mon + "/" + date + " " + hours + ":" + minutes + ":" + seconds;
	}else{
		var now = year + "-" + mon + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
	}
	return now;
}

export function handleExport(data, params) {
	let fileName = params.fileName ? params.fileName : "文档.xlsx";
	if (!data) {
		return;
	}
	let blob = new Blob([data], {
		type: "application/vnd.ms-excel",
	});
	if ("download" in document.createElement("a")) {
		// 不是IE浏览器
		let url = window.URL.createObjectURL(blob);
		let link = document.createElement("a");
		link.style.display = "none";
		link.href = url;
		link.setAttribute("download", fileName);
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link); // 下载完成移除元素
		window.URL.revokeObjectURL(url); // 释放掉blob对象
	} else {
		// IE 10+
		window.navigator.msSaveBlob(blob, fileName);
	}
}



/**
 * tag 企业状态转换
 * @param type
 * @param key
 * @returns {*}
 */
export function formatEntStatus(value,key){
  if(key == 'class'){
    switch(value){
      case -1: return 'examine-ing-adopt'; break;
      case 0: return 'examine-ing-adopt'; break;
      case 1: return 'examine-adopt'; break;
      case 2: return 'examine-no-adopt'; break;
      case 3: return 'examine-no-adopt'; break;
      case 4: return 'examine-no-adopt'; break;
      case 5: return 'examine-adopt'; break;
      case 6: return 'examine-adopt'; break;
      case 7: return 'examine-adopt'; break;
    }
  }
  if(key == 'entStatus'){
    switch(value){
      case -1: return '待提交'; break;
      case 0: return '待审核'; break;
      case 1: return '正常'; break;
      case 2: return '暂停'; break;
      case 3: return '部分暂停'; break;
      case 4: return '核验不通过'; break;
      case 5: return '正常(变更待提交)'; break;
      case 6: return '正常(变更核验中)'; break;
      case 7: return '正常(变更核验不通过)'; break;
    }
  }
  return ""
}


/**
 * tag 数据状态转换
 * @param type
 * @param key
 * @returns {*}
 */
export function formatDataState(value,key){
  if(key == 'class'){
    switch(value){
      case 1: return 'examine-effective'; break;
      case 2: return 'examine-waitSubmit'; break;
      case 3: return 'examine-invalid'; break;
      case 4: return 'examine-waitSubmit'; break;
    }
  }
  if(key == 'dataState'){
    switch(value){
      case 1: return '有效'; break;
      case 2: return '待生效'; break;
      case 3: return '已作废'; break;
      case 4: return '待提交'; break;
    }
  }
  return ""
}

export function rgbaFn (c) {
  // 16进制颜色值的正则
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  // 把颜色值变成小写
  var color = c.toLowerCase();
  if (reg.test(color)) {
      // 如果只有三位的值，需变成六位，如：#fff => #ffffff
      if (color.length === 4) {
      var colorNew = "#";
      for (var i = 1; i < 4; i += 1) {
          colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
      }
      color = colorNew;
      }
      // 处理六位的颜色值，转为RGB
      var colorChange = [];
      for (var i = 1; i < 7; i += 2) {
      colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
      }
      return colorChange.join(",");
  } else {
      return color;
  }
}
var path='';
export function leftMenuFn(){
  let activeMenuIndex=parseInt(sessionStorage.getItem('activeMenuIndex'));
  if(router.currentRoute && router.currentRoute.path=='/cockpit/index'){
    return
  }
  if(activeMenuIndex==0){
    store.commit('common/updateLeftMenu',false)
    router.push({ path: '/home' })
  }else{
    store.commit('common/updateLeftMenu',true)
    findMenu(JSON.parse(sessionStorage.getItem('activeMenuList')));
    router.push({ path: path })
  }
  
  
}
//页面打开默认开启的菜单
function findMenu(route){
  if(route&&route.length>0){
    if(route[0].children&&route[0].children.length>0){
      findMenu(route[0].children)
    }else{
      path=route[0].url
    }
  }

}
var index=0;
var routes=[];
//首页点击详页打开的菜单
export function findMenuItem(route,activeMenu){
  if(route&&route.length>0){
    for(var i in route){
      if(route[i].parentId==0){
        index=i;
        routes=route
      }
      if(route[i].children&&route[i].children.length>0){
        findMenuItem(route[i].children,activeMenu)
      }else{
        // console.log(activeMenu==route[i].routeName,activeMenu,route[i].routeName)
        if(activeMenu==route[i].routeName){
          // 此处更新的是根目录下的菜单
          store.commit('common/updateTopActiveIdx', routes[index].sort);
          store.commit('common/updateTopActiveMenuId', routes[index].id);
          store.commit('common/updateLeftMenuList', routes[index])
          sessionStorage.setItem('activeMenuList',JSON.stringify(routes[index].children))
          sessionStorage.setItem('activeMenuIndex',routes[index].sort);
          window.homeJumpMenuFn && window.homeJumpMenuFn(routes[index].sort,routes[index])
        }
      }
    }
  }
}
// 判断浏览器
export function getBrowserCore () {
  var sBrowser = null
  var sUsrAg = window.navigator.userAgent
  // The order matters here, and this may report false positives for unlisted browsers.
  if (sUsrAg.indexOf('Firefox') > -1) {
    sBrowser = 'Mozilla Firefox'
    // 'Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0'
  } else if (sUsrAg.indexOf('Opera') > -1 || sUsrAg.indexOf('OPR') > -1) {
    sBrowser = 'Opera'
    // 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106'
  } else if (sUsrAg.indexOf('Trident') > -1) {
    sBrowser = 'Microsoft Internet Explorer'
    // 'Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko'
  } else if (sUsrAg.indexOf('Edge') > -1) {
    sBrowser = 'Microsoft Edge'
    // 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299'
  } else if (sUsrAg.indexOf('Chrome') > -1) {
    sBrowser = 'Google Chrome or Chromium'
    // 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36'
  } else if (sUsrAg.indexOf('Safari') > -1) {
    sBrowser = 'Apple Safari'
    // 'Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306'
  } else {
    sBrowser = 'unknown'
  }
  return sBrowser
}

// 获取token信息
export function getToken () {
 return Vue.cookie.get('access_token') || Vue.cookie.get('oauth_access_token')
}
